/**
 * Navigation configuration — extracted from Navbar.jsx
 *
 * Layout: Feed (link) + 3 dropdowns = My Pets / Community / More
 *
 * Removed in 2026-05-03 audit:
 *   - "Discover" dropdown (merged useful items into Community + More)
 *   - Dead-API destinations: /adopt, /channels, /videos, /research, /blog
 *   - AI features (untested): /ai-health
 *   - Premature features: /matchmaking, /elections, /sports, /pro-forums,
 *     /family-tree, /allergens, /jobs, /creative, /products, /deals,
 *     /recommendations, /breed-quiz, /pet-friends, /submissions, /map,
 *     /albums (Photos tab on Profile already covers this)
 */
import {
  Heart, Calendar, Users, Activity, FileText, Trees,
  Building2, PawPrint, MessageSquare, Megaphone, Newspaper, Crown,
  BookOpen, Handshake, Globe, Map, Briefcase, ShieldCheck, Info, Award,
} from 'lucide-react';

export const navGroups = {
  myPets: {
    label: 'My Pets',
    icon: Heart,
    items: [
      { href: '/my-pets', label: 'My Pets', icon: Heart, description: 'Manage your pet profiles' },
      { href: '/calendar', label: 'Pet Calendar', icon: Calendar, description: 'Tasks & reminders' },
      { href: '/health', label: 'Health News', icon: Activity, description: 'Health tracking & articles', guestAccessible: true },
      { href: '/medical-records', label: 'Medical Records', icon: FileText, description: 'Encrypted health records', feature: 'health_records' },
    ],
  },
  community: {
    label: 'Community',
    icon: Users,
    items: [
      { href: '/communities', label: 'Communities', icon: Users, description: 'Topic-based sub-clubs', guestAccessible: true },
      { href: '/forums', label: 'Forums', icon: MessageSquare, description: 'Discussions', guestAccessible: true, feature: 'forums' },
      { href: '/events', label: 'Events', icon: Calendar, description: 'Pet meetups, shows & calendar', guestAccessible: true, feature: 'events' },
      { href: '/breeds', label: 'Breeds', icon: PawPrint, description: 'Breed information', guestAccessible: true },
      { href: '/parks', label: 'Dog Parks', icon: Trees, description: 'Find parks near you', guestAccessible: true },
      { href: '/services', label: 'Services', icon: Briefcase, description: 'Vets, groomers & more', guestAccessible: true },
      { href: '/trusted-providers', label: 'Trusted Independents', icon: Award, description: 'Vets & stores that aren\u2019t PE-owned', guestAccessible: true },
      { href: '/adoption-agencies', label: 'Rescues & Shelters', icon: Building2, description: 'Browse adoption partners', guestAccessible: true, feature: 'adoption' },
      { href: '/partner-program', label: 'Partners', icon: Handshake, description: 'Partner organizations', guestAccessible: true },
      { href: '/kennel-clubs', label: 'Kennel Clubs', icon: Globe, description: 'Worldwide kennel-club directory', guestAccessible: true },
      { href: '/research-library', label: 'Research Library', icon: BookOpen, description: 'Peer-reviewed citations', guestAccessible: true },
    ],
  },
  more: {
    label: 'More',
    icon: Megaphone,
    items: [
      { href: '/about', label: 'About', icon: Info, description: 'About the Club', guestAccessible: true },
      { href: '/club-blog', label: 'Club News', icon: Newspaper, description: 'Updates from leadership', guestAccessible: true },
      { href: '/membership', label: 'Membership', icon: Crown, description: 'Membership tiers', guestAccessible: true },
      { href: '/club-resources', label: 'Club Resources', icon: BookOpen, description: 'Member-only resources' },
      { href: '/trust', label: 'Trust & Data', icon: ShieldCheck, description: 'How we handle your data', guestAccessible: true },
      { href: '/roadmap', label: 'Roadmap', icon: Map, description: 'What we are building', guestAccessible: true },
    ],
  },
};
